export async function readSse(
  body: ReadableStream<Uint8Array>,
  onData: (data: string) => boolean | void
): Promise<void> {
  const reader = body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  let data: string[] = [];

  try {
    while (true) {
      const { done, value } = await reader.read();
      buffer += done ? decoder.decode() : decoder.decode(value, { stream: true });
      let boundary: RegExpExecArray | null;
      while ((boundary = /\r\n|\r|\n/.exec(buffer))) {
        if (!done && boundary[0] === '\r' && boundary.index === buffer.length - 1) break;
        const line = buffer.slice(0, boundary.index);
        buffer = buffer.slice(boundary.index + boundary[0].length);
        if (line === '') {
          if (data.length && onData(data.join('\n')) === false) return;
          data = [];
        } else if (line === 'data' || line.startsWith('data:')) {
          data.push(line.slice(5).replace(/^ /, ''));
        }
      }
      if (done) return;
    }
  } finally {
    await reader.cancel().catch(() => undefined);
    reader.releaseLock();
  }
}
